(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novi-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('novi-hero-slider')) {
    customElements.define('novi-hero-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.interval = Number(this.dataset.interval) || 5000;
        this.canAutoplay = this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.slides.length < 2) return;
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.goTo(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.goTo(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.dot), true)));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.start();
      }

      disconnectedCallback() { this.stop(); }

      goTo(nextIndex, restart) {
        this.index = (nextIndex + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
        if (restart) { this.stop(); this.start(); }
      }

      start() {
        if (!this.canAutoplay || this.slides.length < 2 || this.timer) return;
        this.timer = window.setInterval(() => this.goTo(this.index + 1, false), this.interval);
      }

      stop() {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novi-product-detail"] && !Shopify.designMode) return;
  try {
    
  function initNoviProductDetail(root) {
    if (root.dataset.noviReady === 'true') return;
    root.dataset.noviReady = 'true';

    const galleryImages = Array.from(root.querySelectorAll('[data-gallery-image]'));
    const gallerySwapTargets = Array.from(root.querySelectorAll('[data-gallery-swap]'));
    const colorLabel = root.querySelector('[data-selected-color]');
    const colorProperty = root.querySelector('[data-color-property]');
    const sizeProperty = root.querySelector('[data-size-property]');
    const variantInput = root.querySelector('[data-variant-id]');
    const addButton = root.querySelector('.novi-pdp__form button[name="add"]');
    const priceDisplay = root.querySelector('[data-product-price]');
    const swatches = Array.from(root.querySelectorAll('[data-color-swatch]'));
    const sizeButtons = Array.from(root.querySelectorAll('[data-size-option]'));
    const variantData = root.querySelector('[data-product-variants]');
    const optionData = root.querySelector('[data-product-options]');
    const variants = variantData ? JSON.parse(variantData.textContent) : [];
    const optionNames = optionData ? JSON.parse(optionData.textContent) : [];

    function updateVariant() {
      const colorIndex = optionNames.findIndex((name) => /colou?r/i.test(name));
      const sizeIndex = optionNames.findIndex((name) => /size/i.test(name));
      if (colorIndex < 0 && sizeIndex < 0) return;

      const selectedColor = colorProperty ? colorProperty.value.toLowerCase() : '';
      const selectedSize = sizeProperty ? sizeProperty.value.toLowerCase() : '';
      const match = variants.find((variant) => {
        const colorMatches = colorIndex < 0 || String(variant.options[colorIndex]).toLowerCase() === selectedColor;
        const sizeMatches = sizeIndex < 0 || String(variant.options[sizeIndex]).toLowerCase() === selectedSize;
        return colorMatches && sizeMatches;
      });

      if (!match || !variantInput) return;
      variantInput.value = match.id;
      if (priceDisplay) {
        const moneyFormat = priceDisplay.dataset.moneyFormat || '$0.00';
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          priceDisplay.innerHTML = window.Shopify.formatMoney(match.price, moneyFormat);
        } else {
          priceDisplay.textContent = (Number(match.price) / 100).toFixed(2);
        }
      }
      if (addButton) {
        addButton.disabled = !match.available;
        addButton.textContent = match.available ? 'ADD TO BAG' : 'COMING SOON';
      }
    }

    function exchangeWithPrimary(target) {
      const primaryImage = galleryImages[0];
      const auxiliaryImage = target.querySelector('[data-gallery-image]');
      if (!primaryImage || !auxiliaryImage) return;

      const primaryState = {
        src: primaryImage.getAttribute('src') || '',
        srcset: primaryImage.getAttribute('srcset') || '',
        alt: primaryImage.getAttribute('alt') || ''
      };
      const auxiliaryState = {
        src: auxiliaryImage.getAttribute('src') || '',
        srcset: auxiliaryImage.getAttribute('srcset') || '',
        alt: auxiliaryImage.getAttribute('alt') || ''
      };

      primaryImage.setAttribute('src', auxiliaryState.src);
      primaryImage.setAttribute('srcset', auxiliaryState.srcset);
      primaryImage.setAttribute('alt', auxiliaryState.alt);
      auxiliaryImage.setAttribute('src', primaryState.src);
      auxiliaryImage.setAttribute('srcset', primaryState.srcset);
      auxiliaryImage.setAttribute('alt', primaryState.alt);

      primaryImage.classList.add('is-swapping');
      auxiliaryImage.classList.add('is-swapping');
      window.setTimeout(() => {
        primaryImage.classList.remove('is-swapping');
        auxiliaryImage.classList.remove('is-swapping');
      }, 180);
    }

    gallerySwapTargets.forEach((target) => {
      target.addEventListener('click', () => exchangeWithPrimary(target));
      target.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          exchangeWithPrimary(target);
        }
      });
    });

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        swatches.forEach((item) => {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });
        swatch.classList.add('is-selected');
        swatch.setAttribute('aria-pressed', 'true');

        const colorName = swatch.dataset.colorName || '';
        if (colorLabel) colorLabel.textContent = colorName;
        if (colorProperty) colorProperty.value = colorName;
        const primaryImage = galleryImages[0];
        const nextSource = swatch.dataset.image1;
        if (primaryImage && nextSource) {
          primaryImage.src = nextSource;
          primaryImage.removeAttribute('srcset');
          primaryImage.alt = `${root.dataset.productTitle} - ${colorName}`;
        }
        updateVariant();
      });
    });

    const initialSwatch = swatches.find((swatch) => swatch.classList.contains('is-selected'));
    if (initialSwatch) initialSwatch.click();

    sizeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        sizeButtons.forEach((item) => {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        if (sizeProperty) sizeProperty.value = button.dataset.sizeOption;
        updateVariant();
      });
    });
  }

  function initAllNoviProductDetails(scope) {
    scope.querySelectorAll('[data-novi-pdp]').forEach(initNoviProductDetail);
  }

  initAllNoviProductDetails(document);
  document.addEventListener('shopify:section:load', (event) => initAllNoviProductDetails(event.target));

  } catch(e) { console.error(e); }
})();
})();
